import script from "./CompetitionDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionDetailsPage.vue?vue&type=style&index=0&id=8d029628&lang=css"

const __exports__ = script;

export default __exports__